import { render } from "./coach-details.vue?vue&type=template&id=33a50a0a"
import script from "./coach-details.vue?vue&type=script&lang=js"
export * from "./coach-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__